export function FlaskAnimation() {
  return (
    <div className="flex min-h-[300px] items-center justify-center">
      <svg
        viewBox="0 0 200 280"
        className="w-full max-w-[280px]"
        aria-hidden="true"
      >
        <defs>
          <style>{`
            .flask-bubble {
              animation: flask-rise 3.5s ease-out infinite backwards;
            }
            .flask-prompt {
              animation: flask-blink 1s step-end infinite;
            }
            @keyframes flask-rise {
              0% { transform: translateY(0); opacity: 0; }
              10% { opacity: 0.8; }
              80% { opacity: 0.3; }
              100% { transform: translateY(-70px); opacity: 0; }
            }
            @keyframes flask-blink {
              0%, 100% { opacity: 1; }
              50% { opacity: 0; }
            }
            @media (prefers-reduced-motion: reduce) {
              .flask-bubble { animation: none; opacity: 0.5; }
              .flask-prompt { animation: none; }
            }
          `}</style>
        </defs>

        <g transform="translate(0, 40)">
          <path
            d="M80,30 C72,30 72,34 72,38 L72,78 C40,102 24,134 32,166 C40,190 68,202 100,202 C132,202 160,190 168,166 C176,134 160,102 128,78 L128,38 C128,34 128,30 120,30"
            fill="none"
            stroke="#1a1816"
            strokeWidth="2"
            strokeLinecap="square"
            strokeLinejoin="miter"
          />

          <path
            d="M68,30 C68,26 80,24 100,24 C120,24 132,26 132,30"
            fill="none"
            stroke="#1a1816"
            strokeWidth="2"
            strokeLinecap="square"
          />

          <path
            d="M44,146 C44,126 60,110 100,110 C140,110 156,126 156,146 C160,174 136,198 100,198 C64,198 40,174 44,146 Z"
            fill="#e84a00"
            opacity="0.12"
          />

          <text
            x="64"
            y="172"
            fontFamily="'Space Mono', monospace"
            fontSize="36"
            fontWeight="700"
            fill="#e84a00"
            className="flask-prompt"
          >
            &gt;_
          </text>

          <circle
            cx="112"
            cy="100"
            r="6"
            fill="none"
            stroke="#e84a00"
            strokeWidth="1.5"
            className="flask-bubble"
          />
          <circle
            cx="88"
            cy="90"
            r="4.5"
            fill="none"
            stroke="#1a1816"
            strokeWidth="1.2"
            className="flask-bubble"
            style={{ animationDelay: '0.7s' }}
          />
          <circle
            cx="105"
            cy="80"
            r="3"
            fill="none"
            stroke="#e84a00"
            strokeWidth="1"
            className="flask-bubble"
            style={{ animationDelay: '1.4s' }}
          />
          <circle
            cx="95"
            cy="95"
            r="5"
            fill="none"
            stroke="#1a1816"
            strokeWidth="1.3"
            className="flask-bubble"
            style={{ animationDelay: '2.1s' }}
          />
          <circle
            cx="115"
            cy="85"
            r="2.5"
            fill="none"
            stroke="#e84a00"
            strokeWidth="1"
            className="flask-bubble"
            style={{ animationDelay: '2.8s' }}
          />
          <circle
            cx="82"
            cy="75"
            r="3.5"
            fill="none"
            stroke="#1a1816"
            strokeWidth="1"
            className="flask-bubble"
            style={{ animationDelay: '1.8s' }}
          />
        </g>
      </svg>
    </div>
  );
}
